import $ from 'jquery';

const defaults = {
  selector: 'a',
};

function AccordionFix(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.click = this.click.bind(this);
  this.setVert = this.setVert.bind(this);
  this.listen();
}

AccordionFix.prototype = {
  listen() {
    this.$element.on('click', this.click);
  },
  click(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setVert(event);
  },
  setVert(event) {
    setTimeout(() => {
      const isVis = this.isVisible(event.target);
      if (!isVis) {
        const topOffset = $(this.$element).offset().top - 80;
        $([document.documentElement, document.body]).animate({
          scrollTop: topOffset,
        }, 500);
      }
    }, 500);
  },
  isVisible(e) {
    const elementTop = $(e).offset().top - 80;
    const elementBottom = elementTop + $(e).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    return (elementBottom > viewportTop && elementTop < viewportBottom);
  },
};

export default AccordionFix;
